import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { SocialLink } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import { withRouter } from 'react-router';
import ContactModal from './ContactModal';
import { colors, grid, typography } from '../styles';

const styles = css`
  margin-bottom: 63px;
  @media(min-width: 992px) {
    margin-bottom: 0;
  }
  .heading {
    display: none;
    @media (min-width: 992px) {
      display: block;
      font-size: 26px;
      color: ${colors.brand2};
      text-align: center;
      padding: 40px 0;
      font-weight: 300;
      background-image: url('/images/footer-bg.svg');
      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
  .social-bar {
    padding: 25px 0;
    background-color: #DDD0AA;
  }
  .copyright {
    display: none;
    @media (min-width: 992px) {
      ${grid.makeCol(6)}
      display: block;
    }
  }
  .FooterContent {
    padding: 40px 0;
    background-color: ${colors.neutral};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media(min-width: 992px) {
      flex-direction: row;
      padding: 50px;
      justify-content: space-between;
      align-items: flex-start;
    }
    p {
      text-align: center;
      font-size: 15px;
      @media (min-width: 992px) {
        text-align: left;
      }
    }
    .FooterContentWrapper {
      @media(min-width: 992px) {
        display: flex;
        flex-wrap: nowrap;
      }
    }
  }
  .disclaimer {
    font-weight: 300;
    color: ${colors.brand1};
    font-size: 13px;
    padding: 30px 0 100px 0;
    @media (min-width: 992px) {
      padding: 30px 0;
    }
  }
  .Footer_logo {
    width: 240px;
    margin: 0 0 30px 0;
  }
  .FooterAddressWrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media(min-width: 992px) {
      width: auto;
      align-items: flex-start;
    }
  }

  .SiteByWrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    order: 2;
    @media(min-width: 992px) {
      width: auto;
      order: 1;
      align-items: flex-end;
    }
    .SiteByWrapper_title {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 20px;
      @media(min-width: 400px) {
        flex-direction: row;
        align-items: center;
        padding-bottom: 10px;
      }

      h3 {
        color: ${colors.white};
        font-family: ${typography.Serif};
        font-size: 42px;
        margin-right: 20px;
        font-weight: 400;
      }

      img {
        max-width: 250px;
        margin-right: 10px;
      }
    }

    .SocialLinksWrapper {
      list-style-type: none;
      margin: 0;
      padding: 0;
      display: flex;

      li {
        margin: 0 7px;
      }
    }
    p, a {
      color: ${colors.white};
      letter-spacing: 0.2px;
      font-size: 16px;
      @media(min-width: 992px) {
        font-size: 14px;
        margin-bottom: 5px;
      }
    }
    img {
      margin-left: 5px;
      height: 22px;
      width: auto;
    }

    .Footer_links {
      display: none;
      list-style-type: none;
      @media(min-width: 992px) {
        display: block;
        text-align: right;
        margin: 0;
      }

      li {
        color: ${colors.neutralDarkest};
        position: relative;
        display: inline-block;
        &::after {
          content: "|";
          padding: 0 5px;
        }
        &:last-child {
          &::after {
            content: "";
          }
        }

        a {
          font-size: 15px;
          transition: all .3s ease-out;
          color: ${colors.body};
          &:hover, &:active {
            color: ${colors.brand1};
          }
        }
      }
    }
    .Footer_secondaryLinks {
      display: none;
      list-style-type: none;
      @media(min-width: 992px) {
        display: block;
        text-align: right;
        margin: 15px 0;
        padding: 8px 0;
        border-top: 1px solid ${colors.neutralDarkest};
        border-bottom: 1px solid ${colors.neutralDarkest};
        width: 100%;
      }

      li {
        color: ${colors.neutralDarkest};
        position: relative;
        display: inline-block;
        &::after {
          content: "|";
          padding: 0 5px;
        }
        &:last-child {
          &::after {
            content: "";
          }
        }

        a {
          font-size: 12px;
          transition: all .3s ease-out;
          color: ${colors.body};
          &:hover, &:active {
            color: ${colors.brand1};
          }
        }
        img {
          height: 16px;
          width: auto;
        }
      }
    }
  }
  .Logo_section {
    display: flex;
    background-color: ${colors.brand2};
    height: auto;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
    @media(min-width: 768px) {
      height: 100px;
      padding: 0;
    }

    .Logo_sectionWrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      @media(min-width: 768px) {
        flex-direction: row;
        justify-content: space-between;
      }
    }

    .Logo_item {
      height: 40px;
      width: 95%;
      max-width: 400px;
      object-fit: contain;
    }
  }
  .Disclosures_section {
    display: flex;
    flex-direction: column;
    .Disclosures_wrapper {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px 0;
      font-size: 13px;
      @media(min-width: 768px) {
        flex-direction: row;
      }
      .Disclosures_linksWrapper {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        li {
          padding: 0 5px;
          margin: 0;

          .Disclosures_linksItem {
            font-weight: 800;
            color: ${colors.brand2};
            transition: all .3s ease-out;
            &:hover {
              color: ${colors.brand2};
              transition: all .3s ease-out;
            }
          }
        }
      }
      .All_rights {
        margin: 0;
        text-align: center;
        font-size: 13px;
        line-height: unset;
        a {
          font-weight: 700;
          color: ${colors.brand1};
          transition: all .3s ease-out;
          &:hover {
            color: ${colors.brand1};
            transition: all .3s ease-out;
          }
        }
      }
      .Disclosures_linksImage {
        width: 50px;
        margin-top: 10px;
        @media(min-width: 768px) {
          margin: 0 10px 0 0;
        }
      }
    }
    .Disclosures_links {
      display: flex;
      flex-direction: column;
      align-items: center;
      @media(min-width: 768px) {
        order: 1;
        align-items: flex-start;
      }
    }
    .Disclosures_copy {
      font-size: 11px;
      line-height: 12px;
      color: rgba(33, 37, 41, 0.4);
    }
  }
  .anchored-footer-mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  height: 60px;
  width: 100vw;
  background-color: ${colors.brand1};
  display: flex;
  @media (min-width: 768px) {
    display: none;
  }
  .osc {
    height: 60px;
    width: 60px;
    vertical-align: top;
  }
  .anchored-footer-headline {
    font-family: ${typography.Serif};
    font-size: 21px;
    line-height: 1;
    color: ${colors.white};
    padding: 10px 15px 0 15px;
    background-color: ${colors.brand1Darker};
  }
  .anchored-footer-subheadline {
    font-family: ${typography.SansSerif};
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    color: ${colors.brand2};
    background-color: ${colors.brand1Darker};
    display: block;
    padding-top: 5px;
  }
  .icon-wrapper {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-grow: 1;
  }
  .icon {
    display: block;
    vertical-align: top;
    height: 60px;
    width: auto;
    text-align: center;
    margin: 0 10px;
    color: ${colors.white};
    font-weight: 700;
    img {
      margin: 10px 0 8px 0;
      height: 20px;
      vertical-align: top;
    }
    .email {
      height: 17px;
      margin-top: 13px;
    }
    .text {
      margin-top: 14px;
      margin-bottom: 4px;
    }
    h4 {
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      color: ${colors.white};
    }
  }
}
`;

function Footer({ builder, agent }) {
  return (
    <div className={styles}>
      <div className="FooterContent">
        <div className="FooterAddressWrapper">
          <Link name="index"><img src="/images/mrn-logo.svg" className="Footer_logo" alt={get(builder, 'name')} /></Link>
          <p>
            <strong>{get(builder, 'name')}</strong><br />
            {get(builder, 'address.streetAddress')}<br />
            {get(builder, 'address.addressLocality')}, {get(builder, 'address.addressRegion')} {get(builder, 'address.postalCode')}<br />
            <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}>{get(builder, 'telephone').replace(/\s-\s/, '-')}</a>
          </p>
        </div>
        <div className="SiteByWrapper">
          <ul className="Footer_links">
            <li><Link name="index">Home</Link></li>
            <li><Link name="communities">Find Your Home</Link></li>
            <li><Link name="portfolio">Portfolio</Link></li>
            <li><Link name="about-us">About Us</Link></li>
            <li><Link name="contact-us">Contact Us</Link></li>
          </ul>
          <ul className="Footer_secondaryLinks">
            <li><Link name="privacy-policy" className="Disclosures_linksItem">Privacy Policy</Link></li>
            {/* <li>
              <Link name="terms-of-use" className="Disclosures_linksItem">Terms of Use</Link>
            </li> */}
            <li><img src="/images/icon-equal-housing.svg" alt="Equal Opportunity Housing" /></li>
          </ul>
          <div className="SiteByWrapper_title">
            <ul className="SocialLinksWrapper">
              {
                get(builder, 'socialLinks', []).map(link => (
                  <li key={link}>
                    <SocialLink
                      url={link}
                    />
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="Disclosures_section">
          <div className="Disclosures_wrapper">
            <div className="Disclosures_links">
              <p className="All_rights">&copy; {(new Date()).getFullYear()} {get(builder, 'name')} All Rights Reserved. Site By <a href="https://www.builderdesigns.com" target="_blank" rel="noopener noreferrer">Builder Designs</a></p>
            </div>
            {/* <img src={get(page, 'equal_housing.contentUrl')}
            alt="Equal Housing Icon" className="Disclosures_linksImage" /> */}
          </div>
          {/* {
            get(location, 'pathname') === '/building-green' &&
            <p className="Disclosures_copy">{get(page, 'hers_disclosure')}</p>
          } */}
          {/* <p className="Disclosures_copy">{get(page, 'trendmaker_disclosure')}</p> */}
        </div>
      </div>
      <div className="anchored-footer-mobile">
        {/* <Image
          src={get(agent, 'logo.contentUrl')}
          alt="Online Sales Counselor"
          className="osc"
          width={100}
          height={100}
          exact
        /> */}
        <div className="anchored-footer-headline">
          Questions? <span className="anchored-footer-subheadline">Get Fast Answers!</span>
        </div>
        <div className="icon-wrapper">
          <div className="icon">
            <a href={`tel:${agent.telephone.replace(/[^0-9]/g, '')}`}>
              <img src="/images/icon-mobile-call.svg" alt="Call" />
            </a>
            <h4>Call</h4>
          </div>
          <div className="icon">
            <ContactModal>
              <img src="/images/icon-mobile-email.svg" alt="Email" className="email" />
            </ContactModal>
            <h4>Email</h4>
          </div>
          {
            get(agent, 'text_number') &&
            <div className="icon">
              <a href={`sms:${agent.text_number.replace(/[^0-9]/g, '')}`}>
                <img src="/images/icon-mobile-text.svg" alt="Text" className="text" />
              </a>
              <h4>Text</h4>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

Footer.propTypes = {
  builder: PropTypes.object.isRequired,
  agent: PropTypes.object,
};
Footer.defaultProps = {
  agent: undefined,
};
export default withData({
  builder: true,
  agent: true,
})(withRouter(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer.js